<script setup
        lang="ts">
import { useNProgress } from '@vueuse/integrations/useNProgress';
import { ref }          from 'vue';

const { isLoading } = useNProgress();
const resolved = ref<boolean>(false);
// todo: change to useTemplateRef
const app = ref<HTMLElement | null>(null); // eslint-disable-line
const resolve = (): void => {
    resolved.value = true;
    isLoading.value = false;
    app.value?.scrollIntoView({
        behavior: 'smooth',
    },
    );
};
</script>

<template>
    <div ref="app"
         :class="[
             'flex flex-row',
             'overflow-hidden',
             'h-dvh',
         ]">
        <div ref="scroll"
             :class="[
                 'overflow-auto',
                 'w-full',
             ]">
            <router-view v-slot="{ Component }"
                         :class="[
                             'flex flex-col tablet:flex-row justify-center',
                             'min-h-[calc(100vh-9rem)]',
                         ]">
                <Suspense @resolve="resolve">
                    <component :is="Component" />
                </Suspense>
            </router-view>
        </div>
    </div>
</template>
